import { Builder, withChildren } from '@builder.io/react';

import Box from './index';

const BoxWithBuilderChildren = withChildren(Box);

Builder.registerComponent(BoxWithBuilderChildren, {
  name: 'Box.',
  inputs: [
    {
      name: 'type',
      type: 'string',
      enum: ['gray', 'bordered-gray', 'plain-gray', 'gradient']
    }
  ]
});
